import { createContext, useContext, type ReactNode } from 'react';
import { useStore } from 'zustand';
import type { EstadoNotas, StoreNotas } from '../../application/notas-store';

const Contexto = createContext<StoreNotas | null>(null);

export function ProvedorNotas({ store, children }: { store: StoreNotas; children: ReactNode }) {
  return <Contexto.Provider value={store}>{children}</Contexto.Provider>;
}

/** Lê o estado das notas e setas do quadro aberto. */
export function useNotas<T>(seletor: (estado: EstadoNotas) => T): T {
  const store = useContext(Contexto);
  if (!store) throw new Error('ProvedorNotas ausente');
  return useStore(store, seletor);
}
